/**
 *
 * @module getIdentityTokenResult
 *
 */

import Check from 'check-types';
import Token from './../../token/entry';

import InvalidArgumentException from './../../exception/invalidArgumentException';

const IdentityToken = Token.IdentityToken;
const TemporaryGrant = Token.TemporaryGrant;

const {
    instanceStrict
} = Check.assert;

/**
 *
 * @class GetIdentityTokenResult
 *
 */
export default class GetIdentityTokenResult {

    /**
     *
     * @param {SDK.Services.Token.IdentityToken} identityToken
     * @param {SDK.Services.Token.TemporaryGrant} temporaryGrant
     *
     */
    constructor(identityToken, temporaryGrant) {

        const errorMessage = {
            ctor: 'GetIdentityTokenResult(identityToken, temporaryGrant)',
            get identityToken() {
                return `${this.ctor} needs SDK.Services.Token.IdentityToken instance`;
            },
            get temporaryGrant() {
                return `${this.ctor} needs SDK.Services.Token.TemporaryGrant instance`;
            }
        };

        instanceStrict(
            identityToken,
            IdentityToken,
            errorMessage.identityToken,
            InvalidArgumentException
        );

        instanceStrict(
            temporaryGrant,
            TemporaryGrant,
            errorMessage.temporaryGrant,
            InvalidArgumentException
        );

        /**
         *
         * @access public
         * @type {SDK.Services.Token.IdentityToken}
         * @desc Gets an identity token.
         *
         */
        this.identityToken = identityToken;

        /**
         *
         * @access public
         * @type {SDK.Services.Token.TemporaryGrant}
         * @desc Gets a temporary grant indicating there was a recoverable issue.
         * This grant can be used for authorizing the temporary access to content but not
         * authenticating with the intended identity.
         *
         */
        this.temporaryGrant = temporaryGrant;

    }

}



// WEBPACK FOOTER //
// ./src/services/identity/adobe/getIdentityTokenResult.js